import React from "react";
import Pill from "../../ui/atoms/Pill";

export type EnrolmentStatusType = "active" | "expired" | "upcoming";

interface EnrolmentStatusPillProps {
  status: EnrolmentStatusType;
}

const EnrolmentStatusPill: React.FC<EnrolmentStatusPillProps> = ({ status }) => {
  const classMap: Record<EnrolmentStatusType, string> = {
    active: "enrolment-status-pill active",
    expired: "enrolment-status-pill expired",
    upcoming: "enrolment-status-pill upcoming",
  };

  const labelMap: Record<EnrolmentStatusType, string> = {
    active: "Active",
    expired: "Expired",
    upcoming: "Upcoming",
  };

  return (
    <Pill className={classMap[status] ?? "enrolment-status-pill active"}>
      {labelMap[status] ?? status}
    </Pill>
  );
};

export default EnrolmentStatusPill;
